import React from "react"
/** @jsx jsx */
import { jsx, Styled } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import he from "he"
import striptags from "striptags"

function decodeHtml(html) {
  return striptags(he.decode(html))
}

type CardListProps = {
  filter: any
  diet: any
}

export default ({ filter, diet }: CardListProps) => {
  const data = useStaticQuery(graphql`
    query {
      allNachosYaml {
        nodes {
          id
          cho {
            date
            description
            imageUrl
            mapUrl
            name
            neighborhood
            times
            venue
            venueUrl
            availability
            info
            extras
            choUrl
          }
        }
      }
    }
  `)

  let filteredData = data.allNachosYaml.nodes
  if (filter && filter.length > 0) {
    filteredData = filteredData.slice().filter(node => {
      const check = filter.map(hood => {
        if (node.cho.neighborhood.toLowerCase() === hood.value) {
          return true
        }
      })

      if (check && check.some(item => item === true)) {
        return true
      }
    })
  }

  if (diet && diet.length > 0) {
    filteredData = filteredData.slice().filter(node => {
      const check = diet.map(die => {
        if (node.cho.extras && node.cho.extras.join(" ").match(die.value)) {
          return true
        }
      })

      if (check && check.some(item => item === true)) {
        return true
      }
    })
  }

  return (
    <div
      sx={{
        display: "grid",
        gridTemplateColumns: ["1fr", "1fr 1fr", "1fr 1fr", "repeat(3, 1fr)"],
        gridGap: 4,
      }}
    >
      {filteredData.map(node => {
        const imgSlug = node.cho.name
          .replace(/\r?\n|\r/g, "")
          .trim()
          .replace(/\s+/g, "-")
          .toLowerCase()
        return (
          <div
            key={node.id}
            sx={{
              width: "100%",
              p: 0,
              bg: "muted",
            }}
          >
            <div
              sx={{
                display: "flex",
                flexDirection: "column",
                borderRadius: "2em",
              }}
            >
              <img
                src={`https://res.cloudinary.com/joelmturner/image/upload/w_591/f_auto/q_auto/v1570603656/nachoweek/${imgSlug}.jpg`}
                alt={node.cho.name}
              />
              <div sx={{ display: "flex", flexDirection: "column", p: 3 }}>
                <Styled.h2 sx={{ mb: 3 }}>
                  <a href={node.cho.choUrl} target="_blank">
                    {node.cho.name}
                  </a>
                </Styled.h2>
                {node.cho.venue && (
                  <Styled.h3 sx={{ my: 0 }}>
                    <a href={node.cho.venueUrl} target="_blank">{`${decodeHtml(
                      node.cho.venue
                    )} (${decodeHtml(node.cho.neighborhood)})`}</a>
                  </Styled.h3>
                )}
                {node.cho.availability && (
                  <Styled.p sx={{ mt: 0 }}>
                    {decodeHtml(node.cho.availability)}
                  </Styled.p>
                )}
                <Styled.p>{decodeHtml(node.cho.description)}</Styled.p>
                {node.cho.info && (
                  <Styled.p>{decodeHtml(node.cho.info)}</Styled.p>
                )}
                {node.cho.extras && (
                  <Styled.p>{node.cho.extras.join(", ")}</Styled.p>
                )}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
